export default __webpack_public_path__ + "static/media/mapty.702c6bce.png";